interface Number {
  round(numberOfDecimals: number): number;
}

Number.prototype.round = function (numberOfDecimals: number) {
  const numberValue = this as unknown as number;
  const powerValue = Math.pow(10, numberOfDecimals);
  return Math.round(numberValue * powerValue + 0.00000000000001) / powerValue;
};
